import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PublishToWebMutationVariables = Types.Exact<{
  data: Types.PublishToWebInput;
}>;


export type PublishToWebMutation = { publishToWeb: { success?: boolean | null, errorCode?: Types.ResourceErrorCodeEnum | null, content?: { id: string, name: string, publicAccessConfig?: { publicId: string, isPublic: boolean } | null } | { id: string, name: string, publicAccessConfig?: { publicId: string, isPublic: boolean } | null } | {} | null } };


export const PublishToWebDocument = /*#__PURE__*/ gql`
    mutation publishToWeb($data: PublishToWebInput!) {
  publishToWeb(data: $data) {
    success
    content {
      ... on ArticleContentType {
        id
        publicAccessConfig {
          publicId
          isPublic
        }
        name
      }
      ... on MicroLearningContentType {
        id
        publicAccessConfig {
          publicId
          isPublic
        }
        name
      }
    }
    errorCode
  }
}
    `;

export function usePublishToWebMutation() {
  return Urql.useMutation<PublishToWebMutation, PublishToWebMutationVariables>(PublishToWebDocument);
};